import React, { useState } from 'react';
import {
  LegacyAutocomplete,
  LegacyAutocompleteInput,
  LegacyAutocompleteOptions,
  LegacyAutocompleteSelectedOptions,
} from '@flixbus/honeycomb-react';

import { useVoucherFormContext } from '../../../Context';
import { ForbiddenCountriesRule } from '../../../../../types/Rules';

import { AutocompleteCountry, CountriesAutocomplete, CountriesOptions } from '../Countries';

const ForbiddenCountries = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const countryCodesState =
    (rules.filter(r => r.type === 'forbidden_countries')[0] as ForbiddenCountriesRule | undefined)
      ?.countries || [];

  const convertValuesToOptions = (values: string[]) => {
    return CountriesOptions.filter(option => option.subtitle && values.includes(option.subtitle));
  };

  const [data, setData] = useState<CountriesAutocomplete>([]);
  const [selectedOptions, setSelectedOptions] = useState<CountriesAutocomplete>(
    convertValuesToOptions(countryCodesState),
  );

  const [highlight, setHighlight] = useState<string>('');

  const filterData = (searchQuery: string, data: CountriesAutocomplete) => {
    return data.filter(
      item =>
        item?.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item?.subtitle?.toLowerCase().includes(searchQuery.toLowerCase()),
    );
  };

  const filterOptionsList = (e: React.ChangeEvent<HTMLInputElement>) => {
    setHighlight(e.target.value);
    setData(filterData(e.target.value, CountriesOptions));
  };

  const handleValueChange = (countryCodes: string[]) => {
    handleRuleChange(
      {
        type: 'forbidden_countries',
        countries: countryCodes,
      },
      countryCodes.length === 0,
    );
    setSelectedOptions(convertValuesToOptions(countryCodes));
  };

  const handleItemSelect = (selectedItem: AutocompleteCountry) => {
    if (selectedItem.subtitle && !countryCodesState.includes(selectedItem.subtitle)) {
      handleValueChange(countryCodesState.concat([selectedItem.subtitle]));
      setHighlight('');
      setData([]);
    }
  };

  const handleItemDelete = (selectedItem: AutocompleteCountry) => {
    handleValueChange(countryCodesState.filter(valueItem => valueItem !== selectedItem.subtitle));
  };

  const handleReset = () => {
    handleValueChange([]);
  };

  return (
    <LegacyAutocomplete
      options={data}
      optionsSelected={selectedOptions}
      onDebounce={filterOptionsList}
      onDelete={handleItemDelete}
      onReset={handleReset}
      onSelect={handleItemSelect}
    >
      <LegacyAutocompleteInput
        id='autocomplete-forbidden-countries'
        label='Forbidden countries'
        type='search'
        onFocus={() => {
          setData(CountriesOptions);
        }}
      />
      <LegacyAutocompleteOptions label='Countries' highlightQuery={highlight} />
      <LegacyAutocompleteSelectedOptions
        deleteAllItemsLabel='Clear selection'
        deleteItemLabel='Remove item from selection'
      />
    </LegacyAutocomplete>
  );
};

export default ForbiddenCountries;
